import { addDays, endOfDay, startOfToday } from 'date-fns';

/**
 * How far ahead a customer can book online (QA 2026-09-25 #10: the calendar
 * had no end, and a June 2028 slot booked at the best lead-time price). The
 * server refuses anything past SERVER_BOOKING_HORIZON_DAYS (120) and any
 * time already gone (AppointmentService assertBookable); staff keep their
 * open calendar.
 */
export const BOOKING_HORIZON_DAYS = 90;

/** The last day a customer may pick. */
export function bookingMaxDate(now: Date = new Date()): Date {
  return endOfDay(addDays(now, BOOKING_HORIZON_DAYS));
}

/** Days before today can never be picked, by anyone booking online. */
export function isBeforeToday(day: Date, today: Date = startOfToday()): boolean {
  return day < today;
}

/** A customer's day is out of range: in the past or past the horizon. */
export function isOutsideBookingWindow(
  day: Date,
  now: Date = new Date(),
): boolean {
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  return isBeforeToday(day, today) || day > bookingMaxDate(now);
}
